import Colors from "src/components/Colors";
import styled, { css} from "src/styles/styled-components";
import { BREAKPOINTS, mediaBreakpointUp } from "src/styles/mixins";


export const Container = styled.div`
  position: relative;
`;


export const Header = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 80%;
    z-index: 999;
    height: 100vh;
    padding-top: 70px;
    background-color: #2E2F34;
    transition: .2s ease-in all;

    nav {
        display: flex;
        flex-direction: column;
        min-height: 100%;

        .toggle-mob-menu {
            top: 18px;
            border: none;
            width: 32px;
            right: -140px;
            z-index: 999;
            padding: 4px 8px;
            position: absolute;
            box-shadow: none !important;
            color: ${Colors.black};
            background: transparent;
            display: none;
        }

        .admin-menu {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            padding: 0;
            margin-top: 95px;

            li {
                margin-bottom: 0px;

                > * {
                    width: 100%;
                    padding: 20px 10px;
                }

                a, button {
                    display: flex;
                    align-items: center;
                    text-decoration: none;

                    img {
                        width: 35px;
                        margin-right: 15px;
                        color: ${Colors.white};
                    }

                    span {
                        font-weight: bold;
                        font-size: 16px;
                        color: ${Colors.white};
                    }

                    &.active {
                        background-color: ${Colors.primary};
                        img {
                            color: ${Colors.white};
                        }
    
                        span {
                            color: ${Colors.dark};
                        }
                    }
                }
            }
        }
    }

    .is-minified & {
        left: -80%;
        nav {
            .toggle-mob-menu {
                display: block;
            }
        }
    }

    ${mediaBreakpointUp(BREAKPOINTS.md, css`
        height: 100%;
        width: 360px;
        padding-top: 120px;

        nav {
            .toggle-mob-menu {
                top: auto;
                right: auto;
                left: 20px;
                bottom: 25px;
                color: #fff;
                display: block;
            }

            .admin-menu {
                margin-top: 95px;

                li {
                    > * {
                        padding: 20px 15px;
                    }

                    a, button {
                        img {
                            margin-right: 25px;
                        }

                        span {
                            font-size: 24px;
                            line-height: 33px;
                        }
                    }
                }
            }
        }

        .is-minified & {
            left: 0;
            width: 80px;
            nav {
                .admin-menu {
                    li {
                        a, button {
                            span {
                                display: none;
                            }
                        }
                    }
                }
            }
        }
    `)};

    ${mediaBreakpointUp(BREAKPOINTS.xl, css`
        .is-minified & {
            left: 0;
            width: 360px;

            nav {
                .toggle-mob-menu {
                    display: none;
                }
                .admin-menu {
                    li {
                        a, button {
                            span {
                                display: inline;
                            }
                        }
                    }
                }
            }
        }
    `)};
`;

export const Body = styled.div`
    position: relative;
    min-height: 100vh;
    padding: 10px;
    padding-top: 70px;
    transition: .2s ease-in all;
    background-color: ${Colors.primary};
    background-image: url('/img/bg_account.png');

    .account-header {
        z-index: 9;

        .navbar-toggler {
            display: none;
        }
    }

    ${mediaBreakpointUp(BREAKPOINTS.md, css`
        padding: 30px;
        padding-top: 120px;
        margin-left: 359px;

        .account-header {
            z-index: 999;
        }

        .is-minified & {
            margin-left: 80px;
        }
    `)};

    ${mediaBreakpointUp(BREAKPOINTS.xl, css`
        .is-minified & {
            margin-left: 359px;
        }
    `)};
`;